$(() => $(() => $(document).on('change', '#license_file_hook_service', function() {
  const services = $('#hook_services').data('services');
  const setting_sample = services[this.value].sample_params.settings;
  $('#license_file_hook_settings').attr('placeholder', JSON.stringify(setting_sample));
  const setting_description = services[this.value].description;
  return $('#license_file_hook_description').val(setting_description);
})));